/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.23 9.021a2.21 2.21 0 0 0-2.209 2.21v29.538a2.21 2.21 0 0 0 2.21 2.21H36.77a2.21 2.21 0 0 0 2.209-2.21V29.504a2.01 2.01 0 1 1 4.021 0V40.77A6.23 6.23 0 0 1 36.77 47H7.23A6.23 6.23 0 0 1 1 40.77V11.23A6.23 6.23 0 0 1 7.23 5h11.267a2.01 2.01 0 1 1 0 4.021H7.23z" _fill="#000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M35.292 1.57a2.051 2.051 0 0 1 2.838 0l8.282 8.03c.784.76.784 1.993 0 2.753L25.708 32.43c-.377.365-.887.57-1.42.57h-8.281C14.898 33 14 32.129 14 31.054v-8.03c0-.517.211-1.012.588-1.377L35.292 1.57zM18.013 23.83v5.278h5.444l18.698-18.131-5.444-5.28L18.014 23.83z" _fill="#000"/>'
  }
})
